(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1273,6871],{

/***/ 45432:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}), 'InfoOutlined');

exports.Z = _default;

/***/ }),

/***/ 26871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ CookieConsentPrompt_CookieConsentPrompt; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-cookie-consent/build/index.js
var build = __webpack_require__(92491);
var build_default = /*#__PURE__*/__webpack_require__.n(build);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/InfoOutlined.js
var InfoOutlined = __webpack_require__(45432);
// EXTERNAL MODULE: ./components/CookieConsentPrompt/CookieConsentPrompt.module.scss
var CookieConsentPrompt_module = __webpack_require__(11765);
var CookieConsentPrompt_module_default = /*#__PURE__*/__webpack_require__.n(CookieConsentPrompt_module);
;// CONCATENATED MODULE: ./components/CookieConsentPrompt/CookieConsentPrompt.tsx





var CookieConsentPrompt = function(param) {
    var cookieName = param.cookieName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((build_default()), {
        containerClasses: (CookieConsentPrompt_module_default()).cookieConsent,
        buttonClasses: (CookieConsentPrompt_module_default()).cookieButton,
        declineButtonClasses: (CookieConsentPrompt_module_default()).cookieButton,
        contentClasses: (CookieConsentPrompt_module_default()).cookieContent,
        location: "bottom",
        flipButtons: true,
        expires: 150,
        buttonText: "Acknowledge",
        cookieName: cookieName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {
                className: (CookieConsentPrompt_module_default()).cookieIcon
            }),
            "We use cookies to ensure that we give you the best experience on our website. If you continue to use this site we will assume that you are happy with it."
        ]
    });
};
/* harmony default export */ var CookieConsentPrompt_CookieConsentPrompt = (CookieConsentPrompt);

;// CONCATENATED MODULE: ./components/CookieConsentPrompt/index.ts



/***/ }),

/***/ 11765:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cookieConsent":"CookieConsentPrompt_cookieConsent___08vT","cookieIcon":"CookieConsentPrompt_cookieIcon__pJDf_","cookieButton":"CookieConsentPrompt_cookieButton__rl8_1","cookieContent":"CookieConsentPrompt_cookieContent__A4u52"};

/***/ })

}]);